import { useEffect, useState } from "react";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";

export const ManualAddressForm = ({ onCheckChange }) => {
  const [manualAddress, setManualAddress] = useState(false);

  const handleChange = () => {
    setManualAddress((prev) => !prev);
  };

  useEffect(() => {
    onCheckChange({
      name: "manualLocation",
      value: manualAddress,
    });
  }, [manualAddress]);

  return (
    <div className="mb-3 cursor-pointer">
      <div className="flex justify-end items-center" onClick={handleChange}>
        {manualAddress ? (
          <FaMinusSquare className="text-primary" />
        ) : (
          <FaPlusSquare className="text-primary" />
        )}
        <small className="ml-2">Add Manually</small>
      </div>
    </div>
  );
};
